import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../reducers/authReducer.js";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Uses localStorage

// Persist Configuration
const persistConfig = {
  key: "root",
  storage, // Uses localStorage to store state
  whitelist: ["auth"], // List of reducers to persist
};

// Root reducer wrapped with persistReducer
const rootReducer = combineReducers({
  auth: authReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
  devTools: false,

});

// Create persistor
export const persistor = persistStore(store);

export default store;
